import React, { FC, useCallback } from 'react';
import { Grid, Theme, styled } from '@material-ui/core';
import { SupportContentItem } from './SupportContentItem';
import { useHistory } from 'react-router';
import { useI18nPath } from '../../../config/clientRoutes/hooks';
import { useTranslation } from 'react-i18next';
import { MANUAL_BOOKS } from '../../../config/api/models/Book';
import { useUser } from 'src/modules/shared';

const StyledGridContainer = styled(Grid)<Theme>(({ theme }) => ({
  margin: theme.spacing(0, 0, 4, 0),
}));

export const SupportContent: FC = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const { getPath } = useI18nPath();
  const { user } = useUser();

  const handleMessageClick = () => {
    window.open(
      `https://share-eu1.hsforms.com/1Xy8jtrurReumUQduLGHxBQfgmb9?email=${user.email}`,
      '_blank',
      'noopener'
    );
  };

  const handleMeetingClick = useCallback(() => {
    window.open(
      'https://www.lernova.be/meetings/mattias-van-boven/afspraak-met-lernova',
      '_blank',
      'noopener'
    );
  }, []);

  const handleCallClick = useCallback(() => {
    window.open(`tel:${t('support.call.button')}`, '_blank');
  }, [t]);

  const handleAtSchoolClick = useCallback(() => {
    history.push(getPath('contactMessage'));
  }, [history, getPath]);

  const handleManualClick = useCallback(() => {
    history.push(
      getPath('bookOverview', {
        bookId: MANUAL_BOOKS.teacher,
      })
    );
  }, [history, getPath]);

  return (
    <>
      <StyledGridContainer container spacing={3}>
        <SupportContentItem id="message" primary onClick={handleMessageClick} />
        <SupportContentItem id="meeting" primary onClick={handleMeetingClick} />
        <SupportContentItem id="call" primary onClick={handleCallClick} />
      </StyledGridContainer>
      <StyledGridContainer container spacing={3}>
        <SupportContentItem id="atSchool" onClick={handleAtSchoolClick} />
        <SupportContentItem id="manual" onClick={handleManualClick} />
      </StyledGridContainer>
    </>
  );
};
